/*!
 * lev-source.js  --  WQ-547, Anmeldequelle je Profil
 *
 * ERZEUGT aus growth/klaviyo/source-schema.json durch tools/verify_source_layer.py --emit.
 * NICHT von Hand aendern: der Waechter vergleicht die eingebetteten Tabellen mit dem Schema
 * und wird rot, sobald beide auseinanderlaufen. Tabelle aendern heisst Schema aendern und
 * neu erzeugen.
 *
 * Aufgabe, eine einzige: aus dem aktuellen Seitenaufruf den Kanal ableiten, aus dem eine
 * Besucherin kam, und ihn zusammen mit dem Wahrheitsgrad der Zuordnung bereitstellen. Jede
 * Anmeldung traegt danach kanal UND quelle_methode. Ein leeres Feld gibt es nicht; wo wir
 * es nicht wissen, steht unbekannt mit der Methode intern-unbekannt, und genau das macht
 * die Luecke zaehlbar.
 *
 * Was dieses Modul NICHT tut, und nicht tun darf:
 *   - es sendet nichts. Kein fetch, kein Beacon, kein Pixel. Es rechnet und gibt zurueck.
 *   - es liest und schreibt keine Angabe nach Art. 9 DSGVO. Diese Schicht bleibt allein in
 *     lev-klaviyo.js mit ihrer eigenen Allowlist (Pruefungen K1 bis K9).
 *   - es speichert vom Referrer nur den HOST. Nie Pfad, nie Query, nie Fragment.
 *   - es setzt kein Cookie und keine geraeteuebergreifende Kennung.
 *   - es speichert den Erstkontakt (lev_src, localStorage) NUR nach einem Ja im Shopify-Banner
 *     (Kategorie aus TABLES.einwilligung) und loescht ihn bei Ablehnung und Widerruf.
 *
 * Schnittstelle:
 *   window.LEV_SOURCE.resolve()      -> Objekt mit den Quell-Properties
 *   window.LEV_SOURCE.merge(props)   -> dieselben Properties in ein bestehendes Objekt
 *   window.LEV_SOURCE.stand          -> Stand der Tabelle
 *
 * Geprueft von: python tools/verify_source_layer.py --selftest  (Regeln S1 bis S10)
 */
(function () {
  'use strict';

  var TABLES = {
    "einwilligung": {
      "fassung": "2026-10b",
      "kategorie": "analytics",
      "marker": "lev_ana"
    },
    "erstkontakt_speichern": true,
    "kanaele": [
      "suche-organisch",
      "suche-bezahlt",
      "meta-organisch",
      "meta-bezahlt",
      "pinterest",
      "youtube",
      "linkedin",
      "x",
      "forum",
      "ki-assistent",
      "presse",
      "newsletter",
      "partner",
      "web-verweis",
      "direkt",
      "unbekannt"
    ],
    "pfad_bereiche": [
      "blogs"
    ],
    "properties": [
      {
        "key": "kanal",
        "max": 24,
        "sanitize": ""
      },
      {
        "key": "quelle_methode",
        "max": 20,
        "sanitize": ""
      },
      {
        "key": "kanal_letzt",
        "max": 24,
        "sanitize": ""
      },
      {
        "key": "kampagne",
        "max": 60,
        "sanitize": "slug"
      },
      {
        "key": "anzeige",
        "max": 60,
        "sanitize": "slug"
      },
      {
        "key": "quelle_detail",
        "max": 80,
        "sanitize": "pfad"
      },
      {
        "key": "landeseite",
        "max": 120,
        "sanitize": "pfad"
      },
      {
        "key": "erstkontakt_am",
        "max": 10,
        "sanitize": ""
      }
    ],
    "referrer": [
      [
        "google.com",
        "suche-organisch"
      ],
      [
        "google.de",
        "suche-organisch"
      ],
      [
        "google.at",
        "suche-organisch"
      ],
      [
        "google.ch",
        "suche-organisch"
      ],
      [
        "bing.com",
        "suche-organisch"
      ],
      [
        "duckduckgo.com",
        "suche-organisch"
      ],
      [
        "ecosia.org",
        "suche-organisch"
      ],
      [
        "startpage.com",
        "suche-organisch"
      ],
      [
        "qwant.com",
        "suche-organisch"
      ],
      [
        "search.yahoo.com",
        "suche-organisch"
      ],
      [
        "search.brave.com",
        "suche-organisch"
      ],
      [
        "facebook.com",
        "meta-organisch"
      ],
      [
        "instagram.com",
        "meta-organisch"
      ],
      [
        "pinterest.com",
        "pinterest"
      ],
      [
        "pinterest.de",
        "pinterest"
      ],
      [
        "pin.it",
        "pinterest"
      ],
      [
        "youtube.com",
        "youtube"
      ],
      [
        "youtu.be",
        "youtube"
      ],
      [
        "linkedin.com",
        "linkedin"
      ],
      [
        "lnkd.in",
        "linkedin"
      ],
      [
        "x.com",
        "x"
      ],
      [
        "twitter.com",
        "x"
      ],
      [
        "t.co",
        "x"
      ],
      [
        "reddit.com",
        "forum"
      ],
      [
        "gutefrage.net",
        "forum"
      ],
      [
        "chatgpt.com",
        "ki-assistent"
      ],
      [
        "chat.openai.com",
        "ki-assistent"
      ],
      [
        "perplexity.ai",
        "ki-assistent"
      ],
      [
        "claude.ai",
        "ki-assistent"
      ],
      [
        "gemini.google.com",
        "ki-assistent"
      ],
      [
        "copilot.microsoft.com",
        "ki-assistent"
      ],
      [
        "mail.google.com",
        "newsletter"
      ],
      [
        "outlook.com",
        "newsletter"
      ],
      [
        "outlook.live.com",
        "newsletter"
      ],
      [
        "outlook.office.com",
        "newsletter"
      ],
      [
        "mail.yahoo.com",
        "newsletter"
      ],
      [
        "web.de",
        "newsletter"
      ],
      [
        "gmx.net",
        "newsletter"
      ],
      [
        "gmx.de",
        "newsletter"
      ],
      [
        "t-online.de",
        "newsletter"
      ],
      [
        "com.google.android.gm",
        "newsletter"
      ],
      [
        "com.google.android.googlequicksearchbox",
        "suche-organisch"
      ],
      [
        "levanura.de",
        "intern"
      ],
      [
        "levanura.myshopify.com",
        "intern"
      ]
    ],
    "referrer_verdeckt": [
      [
        "e269dd409ed54f9a",
        "forum"
      ],
      [
        "06a94f26a577d886",
        "forum"
      ],
      [
        "cab1e8709c6b8a12",
        "forum"
      ]
    ],
    "speicher_schluessel": "lev_src",
    "speicher_tage": 90,
    "sperrbegriffe": [
      "symptom",
      "beschwerden",
      "nebenwirkung",
      "krank",
      "diagnos",
      "therapie",
      "behandl",
      "dosis",
      "dosier",
      "spritz",
      "injektion",
      "wirkstoff",
      "rezept",
      "arznei",
      "verstopfung",
      "obstipation",
      "durchfall",
      "uebelkeit",
      "belkeit",
      "erbrechen",
      "sodbrennen",
      "reflux",
      "gastritis",
      "blaehung",
      "voellegefuehl",
      "magen",
      "darm",
      "haarausfall",
      "muskelabbau",
      "muskelverlust",
      "schlaflos",
      "depress",
      "angst",
      "diabet",
      "adipos",
      "uebergewicht",
      "insulinresist",
      "schilddruese",
      "hashimoto",
      "wechseljahr",
      "menopaus",
      "osteoporos",
      "bluthochdruck",
      "cholesterin",
      "glp",
      "semaglutid",
      "tirzepatid",
      "liraglutid",
      "dulaglutid",
      "exenatid",
      "wegovy",
      "ozempic",
      "mounjaro",
      "saxenda",
      "trulicity",
      "zepbound",
      "abnehmspritz",
      "schlankheitsspritz",
      "titration",
      "werkzeugkasten",
      "eiweiss-rechner",
      "erhaltung-rechner",
      "klick-rechner",
      "eiweissluecken-check",
      "wochenplan"
    ],
    "sperre_modus": {
      "anzeige": "verwerfen",
      "kampagne": "verwerfen",
      "landeseite": "pfad-kuerzen",
      "quelle_detail": "verwerfen"
    },
    "stand": "2026-09-12",
    "url_entfernen": [
      "lev_k",
      "lev_kc",
      "_kx"
    ],
    "utm_fallback": {
      "bing": "suche-organisch",
      "facebook": "meta-organisch",
      "forum": "forum",
      "google": "suche-organisch",
      "instagram": "meta-organisch",
      "ki": "ki-assistent",
      "klaviyo": "newsletter",
      "linkedin": "linkedin",
      "meta": "meta-organisch",
      "newsletter": "newsletter",
      "partner": "partner",
      "pinterest": "pinterest",
      "presse": "presse",
      "x": "x",
      "youtube": "youtube"
    },
    "utm_kanal": {
      "bing|cpc": "suche-bezahlt",
      "bing|organisch": "suche-organisch",
      "facebook|cpc": "meta-bezahlt",
      "facebook|organisch": "meta-organisch",
      "facebook|paid-social": "meta-bezahlt",
      "facebook|social": "meta-organisch",
      "google|cpc": "suche-bezahlt",
      "google|organisch": "suche-organisch",
      "instagram|cpc": "meta-bezahlt",
      "instagram|organisch": "meta-organisch",
      "instagram|paid-social": "meta-bezahlt",
      "instagram|social": "meta-organisch",
      "meta|cpc": "meta-bezahlt",
      "meta|organisch": "meta-organisch",
      "meta|paid-social": "meta-bezahlt",
      "meta|social": "meta-organisch"
    },
    "utm_medium_fallback": {
      "email": "newsletter",
      "mail": "newsletter"
    },
    "weitergabe": {
      "param_kampagne": "lev_kc",
      "param_kanal": "lev_k"
    }
  };

  var CAPS = {};
  var SAN_KIND = {};
  (function () {
    for (var i = 0; i < TABLES.properties.length; i++) {
      var p = TABLES.properties[i];
      CAPS[p.key] = p.max;
      SAN_KIND[p.key] = p.sanitize;
    }
  })();

  var CHARS = {
    slug: /[^a-z0-9_-]+/g,
    host: /[^a-z0-9._-]+/g,
    pfad: /[^a-z0-9._\/-]+/g
  };

  // Kleinschreibung, Umlaute aufgeloest, geschlossener Zeichenvorrat, Cap. Der Cap ist
  // kein Komfort, sondern die Zusage aus dem Schema: nichts Langes, nichts Freitextartiges
  // kommt am Profil an. Die Umlaut-Aufloesung ist noetig, damit die Sperrliste einen Pfad
  // auch dann trifft, wenn er im Original mit Umlaut geschrieben ist.
  function san(value, kind, max) {
    var s = String(value === null || value === undefined ? '' : value).toLowerCase();
    s = s.replace(/ä/g, 'ae').replace(/ö/g, 'oe')
         .replace(/ü/g, 'ue').replace(/ß/g, 'ss');
    s = s.replace(CHARS[kind] || CHARS.slug, '-');
    s = s.replace(/-+/g, '-').replace(/^[-\/]+/, '').replace(/-+$/, '');
    if (s.length > max) { s = s.slice(0, max).replace(/-+$/, ''); }
    return s;
  }

  // Sperrliste: ein Wert, der ein Krankheitszeichen oder eine Behandlung benennt, kann
  // ein Datum nach Art. 4 Nr. 15 DSGVO sein und erreicht das Profil deshalb nicht.
  function gesperrt(value) {
    var s = String(value || '');
    for (var i = 0; i < TABLES.sperrbegriffe.length; i++) {
      if (s.indexOf(TABLES.sperrbegriffe[i]) !== -1) { return true; }
    }
    return false;
  }

  // pfad-kuerzen behaelt den Pfad bis VOR dem ersten gesperrten Abschnitt, verwerfen
  // loescht den Wert. Der KANAL bleibt in beiden Faellen stehen: die Messung verliert
  // Tiefe, nie die Zeile.
  function sperre(key, value) {
    var modus = TABLES.sperre_modus[key];
    if (!modus || !value) { return value; }
    if (modus === 'verwerfen') { return gesperrt(value) ? '' : value; }
    var teile = String(value).split('/');
    var behalten = [];
    for (var i = 0; i < teile.length; i++) {
      if (!teile[i]) { continue; }
      if (gesperrt(teile[i])) { break; }
      behalten.push(teile[i]);
    }
    // Veronica 160, Bedingung 2: in diesen Bereichen (Ratgeber) nur der Bereich, nie der Beitrag.
    if (behalten.length && (TABLES.pfad_bereiche || []).indexOf(behalten[0]) !== -1) {
      behalten = behalten.slice(0, 2);
    }
    return behalten.join('/');
  }

  // Zeichenvorrat und Cap je Property kommen AUS DER TABELLE, nicht aus dem Code: sonst
  // waere die Sanitize-Regel eine zweite Wahrheit neben dem Schema.
  function prop(key, value) {
    return sperre(key, san(value, SAN_KIND[key] || 'slug', CAPS[key]));
  }

  function query(search) {
    var out = {};
    var s = String(search || '').replace(/^\?/, '');
    if (!s) { return out; }
    var parts = s.split('&');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) { continue; }
      var eq = parts[i].indexOf('=');
      var k = eq === -1 ? parts[i] : parts[i].slice(0, eq);
      var v = eq === -1 ? '' : parts[i].slice(eq + 1);
      try {
        k = decodeURIComponent(k.replace(/\+/g, ' '));
        v = decodeURIComponent(v.replace(/\+/g, ' '));
      } catch (e) { /* kaputte Prozentfolge: Rohwert, nie ein Abbruch */ }
      if (!Object.prototype.hasOwnProperty.call(out, k)) { out[k] = v; }
    }
    return out;
  }

  // Nur der Host. Der Anker loest auch relative Werte auf; document.referrer ist immer
  // absolut oder leer, deshalb kann hier nichts Fremdes hereinrutschen.
  function hostOf(url) {
    var s = String(url || '').replace(/^\s+|\s+$/g, '');
    if (!s) { return ''; }
    try {
      var a = document.createElement('a');
      a.href = s;
      return String(a.hostname || '').toLowerCase().replace(/^www\./, '');
    } catch (e) { return ''; }
  }

  // FNV-1a, 32 Bit, nur mit Schieben und Addieren (kein Math.imul noetig).
  function fnv1a(text) {
    var h = 0x811c9dc5;
    for (var i = 0; i < text.length; i++) {
      h ^= (text.charCodeAt(i) & 0xff);
      h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return h >>> 0;
  }

  function hex8(n) { return ('00000000' + n.toString(16)).slice(-8); }

  function hostKey(host) {
    return hex8(fnv1a(host)) + hex8(fnv1a(host.split('').reverse().join('')));
  }

  // Suffix-Vergleich, laengstes Suffix gewinnt.
  function referrerKanal(host) {
    var best = '';
    var bestLen = -1;
    for (var i = 0; i < TABLES.referrer.length; i++) {
      var suffix = TABLES.referrer[i][0];
      var tail = '.' + suffix;
      if (host === suffix || host.slice(-tail.length) === tail) {
        if (suffix.length > bestLen) { best = TABLES.referrer[i][1]; bestLen = suffix.length; }
      }
    }
    if (best) { return best; }
    // Verdeckte Tabelle: Foren stehen hier nur als Pruefsumme, nie im Klartext.
    var verdeckt = TABLES.referrer_verdeckt || [];
    var labels = host ? host.split('.') : [];
    for (var j = 0; j < labels.length - 1; j++) {
      var key = hostKey(labels.slice(j).join('.'));
      for (var k = 0; k < verdeckt.length; k++) {
        if (verdeckt[k][0] === key) { return verdeckt[k][1]; }
      }
    }
    return best;
  }

  function currentTouch(href, referrer, mit) {
    var a = document.createElement('a');
    a.href = String(href || '');
    var q = query(a.search);
    var touch = {
      kanal: '', quelle_methode: '', kampagne: '', anzeige: '', quelle_detail: '',
      landeseite: prop('landeseite', a.pathname), erstkontakt_am: ''
    };

    var src = san(q.utm_source, 'slug', 60);
    var med = san(q.utm_medium, 'slug', 60);
    if (src) {
      var kanal = TABLES.utm_kanal[src + '|' + med] || TABLES.utm_fallback[src] ||
        TABLES.utm_medium_fallback[med] || '';
      // Unbekannte utm_source: der Link ist unserer, nur das Vokabular passt nicht. Der
      // Kanal wird web-verweis, quelle_detail nennt den exakten Wert, nichts geht verloren.
      touch.kanal = kanal || 'web-verweis';
      touch.quelle_methode = 'utm';
      touch.quelle_detail = prop('quelle_detail', src + (med ? '/' + med : ''));
      touch.kampagne = prop('kampagne', q.utm_campaign);
      touch.anzeige = prop('anzeige', q.utm_content);
      return touch;
    }

    var host = hostOf(referrer);
    var rk = host ? referrerKanal(host) : '';
    if (mit && (!host || rk === 'intern')) {
      // Kanal-Kuerzel aus dem Link unserer vorigen Seite (Veronica 160, Frage 3): nur Kanal
      // und eigene Kampagne, fuer alle Besucher dieses Kanals gleich, nichts im Browser.
      touch.kanal = mit.kanal;
      touch.quelle_methode = 'weitergabe';
      touch.kampagne = mit.kampagne || '';
      return touch;
    }
    if (!host) {
      touch.kanal = 'direkt';
      touch.quelle_methode = 'direkt';
      return touch;
    }
    if (rk === 'intern') {
      // Interner Sprung: kein neuer Kontakt. Ohne gespeicherten Erstkontakt ist das die
      // ehrliche Luecke, nie ein erfundener Kanal.
      touch.kanal = 'unbekannt';
      touch.quelle_methode = 'intern-unbekannt';
      return touch;
    }
    touch.kanal = rk || 'web-verweis';
    touch.quelle_methode = 'referrer';
    touch.quelle_detail = prop('quelle_detail', host);
    return touch;
  }

  // Speicher: erst localStorage, dann sessionStorage, sonst gar keiner. Jeder Zugriff in
  // try/catch, weil der Browser ihn jederzeit verweigern darf (privater Modus, Richtlinie).
  // Verweigerter Speicher ist kein Fehler, sondern faellt sauber auf Letztkontakt zurueck.
  function store() {
    var names = ['localStorage', 'sessionStorage'];
    for (var i = 0; i < names.length; i++) {
      try {
        var s = window[names[i]];
        var probe = '__lev_src_probe';
        s.setItem(probe, '1');
        s.removeItem(probe);
        return s;
      } catch (e) { /* naechster Versuch */ }
    }
    return null;
  }

  // Einwilligung (Stufe 2, 2026-10-16): der Erstkontakt wird NUR gespeichert und gelesen,
  // wenn das Shopify-Banner die Kategorie aus TABLES.einwilligung erlaubt (Customer
  // Privacy API). Ohne Ja bleibt alles wie in Stufe 1: Letztkontakt, nichts im Browser.
  // Ablehnung und Widerruf loeschen den Eintrag. Der Kontakt DIESES Seitenaufrufs wird
  // beim Laden nur im Speicher gehalten (PENDING) und erst nach einem Ja geschrieben.
  var EINW = TABLES.einwilligung || {};

  function consentNow() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) { return null; }
    try {
      var fn = EINW.kategorie === 'marketing' ? cp.marketingAllowed : cp.analyticsProcessingAllowed;
      return typeof fn === 'function' ? !!fn.call(cp) : null;
    } catch (e) { return null; }
  }

  function markerOk() {
    if (!EINW.marker) { return true; }
    try { return window.localStorage.getItem(EINW.marker) === EINW.fassung; } catch (e) { return false; }
  }

  function setMarker() {
    if (!EINW.marker) { return; }
    try { window.localStorage.setItem(EINW.marker, EINW.fassung); } catch (e) { /* ohne Speicher kein Erstkontakt */ }
  }

  function erlaubt() {
    return !!TABLES.erstkontakt_speichern && consentNow() === true && markerOk();
  }

  function forget() {
    var names = ['localStorage', 'sessionStorage'];
    for (var i = 0; i < names.length; i++) {
      try {
        window[names[i]].removeItem(TABLES.speicher_schluessel);
        if (EINW.marker) { window[names[i]].removeItem(EINW.marker); }
      } catch (e) { /* nichts zu loeschen */ }
    }
  }

  function readFirst() {
    if (!erlaubt()) { return null; }
    var s = store();
    if (!s) { return null; }
    try {
      var raw = s.getItem(TABLES.speicher_schluessel);
      if (!raw) { return null; }
      var obj = JSON.parse(raw);
      if (!obj || typeof obj !== 'object' || !obj.kanal) { return null; }
      var age = (Date.now() - Number(obj.ts || 0)) / 86400000;
      if (!(age >= 0) || age > TABLES.speicher_tage) {
        s.removeItem(TABLES.speicher_schluessel);
        return null;
      }
      return obj;
    } catch (e) { return null; }
  }

  function writeFirst(touch) {
    if (!erlaubt()) { return false; }
    if (!touch || touch.quelle_methode === 'intern-unbekannt') { return false; }
    var s = store();
    if (!s) { return false; }
    try {
      if (s.getItem(TABLES.speicher_schluessel)) { return false; }
      var now = new Date();
      var entry = {
        kanal: touch.kanal, quelle_methode: touch.quelle_methode,
        kampagne: touch.kampagne, anzeige: touch.anzeige,
        quelle_detail: touch.quelle_detail, landeseite: touch.landeseite,
        erstkontakt_am: now.toISOString().slice(0, 10), ts: now.getTime()
      };
      s.setItem(TABLES.speicher_schluessel, JSON.stringify(entry));
      return true;
    } catch (e) { return false; }
  }

  function resolve() {
    var cur = currentTouch(window.location && window.location.href, document.referrer, CARRIED);
    var first = readFirst();
    var base = first || cur;
    var out = {
      kanal: base.kanal || 'unbekannt',
      quelle_methode: base.quelle_methode || 'intern-unbekannt'
    };
    // kanal_letzt gibt es nur neben einem gespeicherten Erstkontakt. Ohne ihn waere es eine
    // Verdopplung von kanal, und die Datenschutzerklaerung beschreibt es nur fuer diesen Fall.
    if (first) { out.kanal_letzt = cur.kanal || 'unbekannt'; }
    var optional = ['kampagne', 'anzeige', 'quelle_detail', 'landeseite'];
    for (var i = 0; i < optional.length; i++) {
      if (base[optional[i]]) { out[optional[i]] = base[optional[i]]; }
    }
    if (first && first.erstkontakt_am) { out.erstkontakt_am = first.erstkontakt_am; }
    return out;
  }

  // Eine Zeile je Transportweg: LEV_SOURCE.merge(props). Bestehende Schluessel bleiben
  // unangetastet, die Quell-Schluessel sind von der Allowlist in lev-klaviyo.js disjunkt.
  function merge(props) {
    var target = props || {};
    var src = resolve();
    for (var key in src) {
      if (Object.prototype.hasOwnProperty.call(src, key) && src[key]) { target[key] = src[key]; }
    }
    return target;
  }

  // Kanal-Kuerzel aus dem Link der vorigen eigenen Seite lesen, dann die Kuerzel und Klaviyos
  // _kx aus der Adresse entfernen, BEVOR Werbe-Tags die Adresse lesen (Veronica 160,
  // Bedingungen 3 und 5). Dieses Skript ist defer und laeuft vor DOMContentLoaded, die
  // Werbe-Tags starten erst danach.
  function carried(href) {
    var w = TABLES.weitergabe || {};
    if (!w.param_kanal) { return null; }
    var a = document.createElement('a');
    a.href = String(href || '');
    var q = query(a.search);
    var k = san(q[w.param_kanal], 'slug', 24);
    if (!k || TABLES.kanaele.indexOf(k) === -1 || k === 'unbekannt') { return null; }
    return {kanal: k, kampagne: prop('kampagne', q[w.param_kampagne])};
  }

  function cleanUrl() {
    var weg = TABLES.url_entfernen || [];
    if (!weg.length || !window.history || typeof window.history.replaceState !== 'function') { return; }
    var u = new URL(window.location.href);
    var hit = false;
    for (var i = 0; i < weg.length; i++) {
      if (u.searchParams.has(weg[i])) { u.searchParams['delete'](weg[i]); hit = true; }
    }
    if (hit) { window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash); }
  }

  var CARRIED = null;
  try { CARRIED = carried(window.location && window.location.href); cleanUrl(); }
  catch (e) { /* nie den Seitenaufbau stoeren */ }

  var PENDING = null;
  try { PENDING = currentTouch(window.location && window.location.href, document.referrer, CARRIED); }
  catch (e) { /* nie den Seitenaufbau stoeren */ }

  // Ohne Ja im Banner: den Kanal dieses Besuchs im Moment des Klicks an unsere eigenen
  // Links haengen (nie vorher, damit Suchmaschinen keine veraenderten Links sehen).
  function weiterKanal() {
    if (erlaubt()) { return null; }
    var t = PENDING;
    if (!t || !t.kanal || t.kanal === 'unbekannt' || t.kanal === 'direkt') { return null; }
    return t;
  }

  function dekoriere(ev) {
    try {
      var w = weiterKanal();
      var p = TABLES.weitergabe || {};
      if (!w || !p.param_kanal) { return; }
      var el = ev.target;
      while (el && el.nodeName !== 'A') { el = el.parentNode; }
      if (!el || !el.href) { return; }
      var u = new URL(el.href, window.location.href);
      if (u.hostname !== window.location.hostname || !/^https?:$/.test(u.protocol)) { return; }
      if (u.pathname === window.location.pathname && u.hash) { return; }
      u.searchParams.set(p.param_kanal, w.kanal);
      if (w.kampagne) { u.searchParams.set(p.param_kampagne, w.kampagne); }
      else { u.searchParams['delete'](p.param_kampagne); }
      el.href = u.toString();
    } catch (e) { /* nie einen Klick stoeren */ }
  }
  document.addEventListener('pointerdown', dekoriere, true);
  document.addEventListener('click', dekoriere, true);

  // Gespeicherte Entscheidung beim Seitenaufruf: Ja = diesen Kontakt festhalten (nur wenn es
  // noch keinen gibt), Nein = Eintrag loeschen, unbekannt = nichts tun.
  function apply() {
    try {
      var c = consentNow();
      if (c === true && markerOk()) { writeFirst(PENDING); }
      else if (c === false) { forget(); }
    } catch (e) { /* nie den Seitenaufbau stoeren */ }
  }

  // Entscheidung im Banner, auch jede spaetere Aenderung ueber "Cookie-Einstellungen".
  document.addEventListener('visitorConsentCollected', function (ev) {
    try {
      var d = (ev && ev.detail) || {};
      var ja = EINW.kategorie === 'marketing' ? d.marketingAllowed : d.analyticsAllowed;
      if (ja) { setMarker(); writeFirst(PENDING); } else { forget(); }
    } catch (e) { /* nie den Seitenaufbau stoeren */ }
  });

  function boot() {
    if (!TABLES.erstkontakt_speichern) { return; }
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (err) {
          if (!err) { apply(); }
        });
      } else {
        apply();
      }
    } catch (e) { /* nie den Seitenaufbau stoeren */ }
  }

  window.LEV_SOURCE = {resolve: resolve, merge: merge, stand: TABLES.stand};
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
